import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider, setPersistence, browserLocalPersistence } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getAnalytics } from "firebase/analytics";
import { getStorage } from "firebase/storage"

const firebaseConfig = {
  apiKey: "AIzaSyDgku65fyUaPVLGX5rEV5rTl9gExiq5GOM",
  authDomain: "racketriotclub-98ec9.firebaseapp.com",
  projectId: "racketriotclub-98ec9",
  storageBucket: "racketriotclub-98ec9.firebasestorage.app",
  appId: "1:966143075543:web:60bf16b4e3617563c93c92",
  messagingSenderId: "966143075543",
  measurementId: "G-1PKQ9E3VLT"
};

const app = initializeApp(firebaseConfig);

// Auth
const auth = getAuth(app);
const provider = new GoogleAuthProvider();
setPersistence(auth, browserLocalPersistence);

// Firestore (REQUIRED for Phase 1+)
const db = getFirestore(app);

// Analytics (optional)
const analytics = getAnalytics(app);
const storage = getStorage(app);
export { auth, provider, db, analytics, storage, app };
